// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ChartComponent.css */

/* Style for the outer container */
.chart-component-container {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /*height: 100vh; /* Full viewport height */
}

.toggle-buttons-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  /*margin-bottom: .5rem;*/
}

/* Style for checkbox container */
.checkbox-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;  /* Reduce padding to make it smaller */
  margin: 0.5rem;  /* Reduce margin to make buttons closer together */
  cursor: pointer;
  font-size: 16px;  /* Decrease font size */
  -webkit-user-select: none;
          user-select: none;
  color: white;
}

/* Hide the default checkbox */
.checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Custom checkmark */
.checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 18px;  /* Decrease height */
  width: 18px;   /* Decrease width */
  background-color: #333;
  border: 2px solid #B18800;
  border-radius: 5px;
  transition: background-color 0.3s ease;
}

/* On hover, add a background color */
.checkbox-container:hover input ~ .checkmark {
  background-color: #666;
}

/* When the checkbox is checked, change the background color */
.checkbox-container input:checked ~ .checkmark {
  background-color: #B18800;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.checkbox-container .checkmark:after {
  left: 6px;  /* Adjust left position */
  top: 3px;   /* Adjust top position */
  width: 4px; /* Adjust width */
  height: 8px; /* Adjust height */
  border: solid white;
  border-width: 0 2px 2px 0;  /* Adjust border width */
  transform: rotate(45deg);
}
/* Style for the overlays */
.overlay {
  position: absolute;
  top: 10px; /* Adjust to move the overlay vertically */
  left: 10px; /* Adjust to move the overlay horizontally */
  color: white;
  font-size: 16px;
  pointer-events: none; /* Ensures the overlay does not block interactions with the chart */
  background-color: rgba(0, 0, 0, 0.5); /* Optional: Add a background for better readability */
  padding: 5px;
  border-radius: 5px;
  z-index: 10; /* Ensures the overlay is on top of the chart */
}



/*!* ChartComponent.css *!*/

/*!* Style for the outer container *!*/
/*.chart-component-container {*/
/*  display: flex;*/
/*  flex-wrap: wrap;*/
/*  flex-direction: column;*/
/*  justify-content: center;*/
/*  align-items: center;*/
/*  !*height: 100vh; !* Full viewport height *!*/

/*}*/

/*.toggle-buttons-container {*/
/*  display: flex;*/
/*  flex-wrap: wrap;*/
/*  justify-content: center;*/
/*  !*margin-bottom: .5rem;*!*/
/*}*/

/*.toggle-button {*/
/*  background-color: #333;*/
/*  color: white;*/
/*  padding: 0.5rem 1rem;*/
/*  margin: 1rem;*/
/*  border: none;*/
/*  cursor: pointer;*/
/*  border-radius: 5px;*/
/*}*/




`, "",{"version":3,"sources":["webpack://./src/Components/Style.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB,kCAAkC;AAClC;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,iCAAiC;AACjC;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB,GAAG,sCAAsC;EAC3D,cAAc,GAAG,kDAAkD;EACnE,eAAe;EACf,eAAe,GAAG,uBAAuB;EACzC,yBAAiB;UAAjB,iBAAiB;EACjB,YAAY;AACd;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY,GAAG,oBAAoB;EACnC,WAAW,IAAI,mBAAmB;EAClC,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,qCAAqC;AACrC;EACE,sBAAsB;AACxB;;AAEA,8DAA8D;AAC9D;EACE,yBAAyB;AAC3B;;AAEA,6DAA6D;AAC7D;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;AACf;;AAEA,oCAAoC;AACpC;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,SAAS,GAAG,yBAAyB;EACrC,QAAQ,IAAI,wBAAwB;EACpC,UAAU,EAAE,iBAAiB;EAC7B,WAAW,EAAE,kBAAkB;EAC/B,mBAAmB;EACnB,yBAAyB,GAAG,wBAAwB;EACpD,wBAAwB;AAC1B;AACA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,SAAS,EAAE,0CAA0C;EACrD,UAAU,EAAE,4CAA4C;EACxD,YAAY;EACZ,eAAe;EACf,oBAAoB,EAAE,mEAAmE;EACzF,oCAAoC,EAAE,sDAAsD;EAC5F,YAAY;EACZ,kBAAkB;EAClB,WAAW,EAAE,+CAA+C;AAC9D;;;;AAIA,2BAA2B;;AAE3B,sCAAsC;AACtC,+BAA+B;AAC/B,mBAAmB;AACnB,qBAAqB;AACrB,4BAA4B;AAC5B,6BAA6B;AAC7B,yBAAyB;AACzB,gDAAgD;;AAEhD,IAAI;;AAEJ,8BAA8B;AAC9B,mBAAmB;AACnB,qBAAqB;AACrB,6BAA6B;AAC7B,8BAA8B;AAC9B,IAAI;;AAEJ,mBAAmB;AACnB,4BAA4B;AAC5B,kBAAkB;AAClB,0BAA0B;AAC1B,kBAAkB;AAClB,kBAAkB;AAClB,qBAAqB;AACrB,wBAAwB;AACxB,IAAI","sourcesContent":["/* ChartComponent.css */\n\n/* Style for the outer container */\n.chart-component-container {\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  /*height: 100vh; /* Full viewport height */\n}\n\n.toggle-buttons-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  /*margin-bottom: .5rem;*/\n}\n\n/* Style for checkbox container */\n.checkbox-container {\n  display: inline-block;\n  position: relative;\n  padding-left: 30px;  /* Reduce padding to make it smaller */\n  margin: 0.5rem;  /* Reduce margin to make buttons closer together */\n  cursor: pointer;\n  font-size: 16px;  /* Decrease font size */\n  user-select: none;\n  color: white;\n}\n\n/* Hide the default checkbox */\n.checkbox-container input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  height: 0;\n  width: 0;\n}\n\n/* Custom checkmark */\n.checkmark {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 18px;  /* Decrease height */\n  width: 18px;   /* Decrease width */\n  background-color: #333;\n  border: 2px solid #B18800;\n  border-radius: 5px;\n  transition: background-color 0.3s ease;\n}\n\n/* On hover, add a background color */\n.checkbox-container:hover input ~ .checkmark {\n  background-color: #666;\n}\n\n/* When the checkbox is checked, change the background color */\n.checkbox-container input:checked ~ .checkmark {\n  background-color: #B18800;\n}\n\n/* Create the checkmark/indicator (hidden when not checked) */\n.checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n\n/* Show the checkmark when checked */\n.checkbox-container input:checked ~ .checkmark:after {\n  display: block;\n}\n\n/* Style the checkmark/indicator */\n.checkbox-container .checkmark:after {\n  left: 6px;  /* Adjust left position */\n  top: 3px;   /* Adjust top position */\n  width: 4px; /* Adjust width */\n  height: 8px; /* Adjust height */\n  border: solid white;\n  border-width: 0 2px 2px 0;  /* Adjust border width */\n  transform: rotate(45deg);\n}\n/* Style for the overlays */\n.overlay {\n  position: absolute;\n  top: 10px; /* Adjust to move the overlay vertically */\n  left: 10px; /* Adjust to move the overlay horizontally */\n  color: white;\n  font-size: 16px;\n  pointer-events: none; /* Ensures the overlay does not block interactions with the chart */\n  background-color: rgba(0, 0, 0, 0.5); /* Optional: Add a background for better readability */\n  padding: 5px;\n  border-radius: 5px;\n  z-index: 10; /* Ensures the overlay is on top of the chart */\n}\n\n\n\n/*!* ChartComponent.css *!*/\n\n/*!* Style for the outer container *!*/\n/*.chart-component-container {*/\n/*  display: flex;*/\n/*  flex-wrap: wrap;*/\n/*  flex-direction: column;*/\n/*  justify-content: center;*/\n/*  align-items: center;*/\n/*  !*height: 100vh; !* Full viewport height *!*/\n\n/*}*/\n\n/*.toggle-buttons-container {*/\n/*  display: flex;*/\n/*  flex-wrap: wrap;*/\n/*  justify-content: center;*/\n/*  !*margin-bottom: .5rem;*!*/\n/*}*/\n\n/*.toggle-button {*/\n/*  background-color: #333;*/\n/*  color: white;*/\n/*  padding: 0.5rem 1rem;*/\n/*  margin: 1rem;*/\n/*  border: none;*/\n/*  cursor: pointer;*/\n/*  border-radius: 5px;*/\n/*}*/\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
